var render = function () {
  var _vm$comment, _vm$comment$createdAt;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "answer-item__con"
  }, [_c('div', {
    staticClass: "answer-item__nickname"
  }, [_vm._v(" " + _vm._s(_vm.commenterName) + " ")]), _c('div', {
    staticClass: "answer-item__content"
  }, [_vm._v(" " + _vm._s(_vm.comment.content) + " ")]), _c('div', {
    staticClass: "answer-item__info"
  }, [_c('div', [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "white-space": "none"
    }
  }, [_vm._v(_vm._s((_vm$comment = _vm.comment) === null || _vm$comment === void 0 ? void 0 : (_vm$comment$createdAt = _vm$comment.createdAt) === null || _vm$comment$createdAt === void 0 ? void 0 : _vm$comment$createdAt.toDateTime()))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isCommenter,
      expression: "isCommenter"
    }]
  }, [_c('span', {
    staticClass: "answer-item__info-col"
  }, [_c('response-comment-modify', {
    attrs: {
      "comment": _vm.comment
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('span', {
    staticClass: "answer-item__info-col"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("삭제")])], 1)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }